// import axios from "axios";
import firebase from "../../firebase";

import * as actionTypes from "./actionTypes";

// const firebaseKey = "";

export const authStart = () => {
  return {
    type: actionTypes.AUTH_START,
  };
};

const authSuccess = (userId, message) => {
  return {
    type: actionTypes.AUTH_SUCCESS,
    userId: userId,
    message: message,
  };
};

export const authFail = (error) => {
  return {
    type: actionTypes.AUTH_FAIL,
    error: error,
  };
};

export const login = (email, password) => {
  return (dispatch) => {
    dispatch(authStart());
    firebase
      .auth()
      .signInWithEmailAndPassword(email, password)
      .then((response) => {
        dispatch(authSuccess(response.user.uid, null));
      })
      .catch(function (error) {
        // Handle Errors here.
        var errorCode = error.code;
        var errorMessage = error.message;
        console.log(errorCode);
        console.log(errorMessage);
        dispatch(authFail(errorMessage));
      });
  };
};

export const signup = (userData) => {
  return (dispatch) => {
    dispatch(authStart());
    firebase
      .auth()
      .createUserWithEmailAndPassword(userData.email, userData.password)
      .then((response) => {
        firebase
          .database()
          .ref("users/" + response.user.uid)
          .set({
            firstname: userData.first,
            lastname: userData.last,
            email: userData.email,
          })
          .then(() => {
            dispatch(authSuccess(response.user.uid, null));
          });
      })
      .catch(function (error) {
        // Handle Errors here.
        var errorCode = error.code;
        var errorMessage = error.message;
        console.log(errorCode);
        console.log(errorMessage);
        dispatch(authFail(errorMessage));
      });
  };
};

// updating the redux auth state to reflect the firebase auth state
export const updateAuth = (uid) => {
  return {
    type: actionTypes.UPDATE_AUTH_STATE,
    userId: uid,
  };
};

export const logout = () => {
  return (dispatch) => {
    dispatch(authStart());
    firebase
      .auth()
      .signOut()
      .then(function () {
        dispatch({ type: actionTypes.LOGOUT });
      })
      .catch(function (error) {
        var errorCode = error.code;
        var errorMessage = error.message;
        console.log(errorCode);
        console.log(errorMessage);
        dispatch(authFail(errorMessage));
      });
  };
};

export const resetPassword = (email) => {
  return (dispatch) => {
    dispatch(authStart());
    firebase
      .auth()
      .sendPasswordResetEmail(email)
      .then(function () {
        dispatch(
          authSuccess(
            null,
            "Password Reset email has been sent. Please check your inbox."
          )
        );
      })
      .catch(function (error) {
        dispatch(
          authFail(
            "Invalid email address. Please enter an existing email address or create an account."
          )
        );
      });
  };
};

export const resetState = () => {
  return {
    type: actionTypes.RESET_STATE,
  };
};
